<script>
import { Bar, mixins } from 'vue-chartjs'

const { reactiveData } = mixins

let steps = [
  'user_login',
  'complete_agreement',
  'syscheck_result',
  'take_photo_send',
  'take_photo_approved',
  'start_exam',
  'stop_exam',
  'user_logout'
]

export let getChartData = events => ({
  labels: steps,
  datasets: [
    {
      label: 'Events',
      backgroundColor: '#BDBDBD66',
      data: steps.map(step => events
        .filter(x => x.eventType === step)
        .length)
    }
  ]
})

export default {
  extends: Bar,
  props: {
    events: Array
  },
  mixins: [reactiveData],
  watch: {
    events (ev) {
      this.chartData = getChartData(ev)
    }
  },
  computed: {
    options () {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        tooltips: {
          enabled: false
        },
        scales: {
          yAxes: [{
            ticks: {
              suggestedMax: 10,
              stepSize: 5
            }
          }]
        }
      }
    }
  },
  mounted () {
    this.chartData = getChartData(this.events)
    this.renderChart(this.chartData, this.options)
  }
}
</script>

<style scoped>

</style>
